import { useGetAllClusters } from "../../../assets/api/useAdminApi";
import useAuthStore from "../../../store/useAuthStore";

export const useClusterOptions = (filters) => {
    const { user } = useAuthStore();

    const { data: addedClusterList, isLoading: isLoadingaddedClusterList } =
        useGetAllClusters(filters);

    const clusterList = addedClusterList || [];

    const role = user?.role;

    const isClusterWiseRole =
        role === "Marketing Executive" || role === "Zonal Coordinator";

    const isMarketingManager = role === "Marketing Manager";

    let filteredList = clusterList;

    /** ------------------------------------
     * 1️⃣ FILTER BY ZONE IDs (Executive / Coordinator)
     * user.zone_id = [8,7,13]
     * cluster.zone_id = 8 (single number)
     * ------------------------------------ */
    if (isClusterWiseRole) {
        const userZoneIds = user?.zone_id || []; // <-- use this directly
        filteredList = clusterList?.filter((cluster) =>
            userZoneIds?.includes(cluster?.zone_id)
        );
    }

    /** ------------------------------------
     * 2️⃣ FILTER BY CITY NAME (Marketing Manager)
     * ------------------------------------ */
    if (isMarketingManager) {
        const userCityName = user?.city?.toLowerCase();
        filteredList = clusterList.filter(
            (cluster) => cluster?.city_name?.toLowerCase() === userCityName
        );
    }

    /** ------------------------------------
     * 3️⃣ MAP OPTIONS FOR DROPDOWN
     * ------------------------------------ */
    const AddedClusterOption = filteredList.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        label: item.cluster_name,
        value: item.cluster_name,
        ...item,
    }));

    return {
        AddedClusterOptions: {
            options: AddedClusterOption,
            isLoading: isLoadingaddedClusterList,
        },
    };
};
